import widgetTypes from './widgetTypes';
// eslint-disable-next-line import/prefer-default-export
export const IMPRESSION_LISTEN_TIMEOUT = 20000; //  in milliseconds
export const IMP_DATA_COLLECTOR_TIMEOUT = 5000; // in milliseconds
export const VIEWABLE_THRESHOLD = 50; // percent
export const IMP_STORAGE_KEY_V2 = 'HP_IMP_V2';
// widgets needs to transform their styles other than V2
export const transformStyleWidgetTypes = [
    widgetTypes.LIST_VIEW_WIDGET,
    widgetTypes.LIST_VIEW_CHILD
];
export const STORY_WIDGET_TYPE = {
    DYNAMIC_HTML: 'DYNAMIC_HTML',
    STATIC_HTML: 'STATIC_HTML',
};
export const PRODUCT_EVENT = {
    IMPRESSIONS: 'product_impression',
    CLICK: 'product_card_clicked',
};
